import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { getDashboardAchievements } from '../../../actions/Dashboard/AchievementsActions';
import { StateType } from '../../../reducers';
import {
  achievementsDataSelector,
  achievementsIsFetchingSelector,
} from '../../../reducers/DashboardReducer/AchievementsReducer/AchievementsSelector';
import { DispatchConnect } from '../../../types/';

import { AchievementsPropsGeneric, AchievementsStateDispatchers, AchievementsStateProps } from './types';
import AchievementsMain from './AchievementsMain';

class Achievements extends React.Component<AchievementsPropsGeneric> {
  UNSAFE_componentWillMount() {
    this.props.dispatchGetDashboardAchievements();
  }

  render() {
    return <AchievementsMain data={this.props.data} isFetching={this.props.isFetching} />;
  }
}

const mapStateToProps = (state: StateType): AchievementsStateProps => ({
  // @ts-ignore
  data: achievementsDataSelector(state),
  // @ts-ignore
  isFetching: achievementsIsFetchingSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): AchievementsStateDispatchers => ({
  dispatchGetDashboardAchievements: async () => dispatch(getDashboardAchievements()),
});

export default connect<AchievementsStateProps, DispatchConnect<AchievementsStateDispatchers>, any, StateType>(
  mapStateToProps,
  mapDispatchToProps
)(Achievements);
